import React from "react";
import { Box, Container, Typography, useTheme } from "@mui/material";
import NewAppBar from "components/Navbars/AppBar";
import Footer from "views/Landing/Footer";
import { useTranslation } from "react-i18next";

const Policies = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <NewAppBar />
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "white",
          pt: { xs: 2, sm: 4, md: 8 },
          pb: { xs: 2, sm: 4, md: 6 },
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "16px",
              border: "1px solid #E5E5E5",
              boxShadow: "none",
              p: { xs: 2, sm: 4, md: 6 },
              mb: 4,
            }}
          >
            <Typography
              sx={{
                fontSize: "28px",
                fontFamily: "Poppins",
                fontWeight: 700,
                color: "#0017E7",
                mb: 4,
                textAlign: "flex-start",
              }}
            >
              {t("policies.title") || "TalentyHire Policies"}
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#333",
                mb: 2,
                mt: 4,
              }}
            >
              {t("policies.introductionTitle") || "Introduction"}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#666",
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              {t("policies.introductionContent") ||
                "Welcome to TalentyHire's policies page. Here you will find important information about our terms of service, privacy policy, and other legal agreements that govern your use of the TalentyHire platform. TalentyHire is an AI-powered recruitment platform designed to streamline the hiring process for employers and job seekers alike."}
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#333",
                mb: 2,
                mt: 4,
              }}
            >
              {t("policies.termsOfServiceTitle") || "Terms of Service"}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#666",
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              {t("policies.termsOfServiceContent") ||
                "By accessing and using the TalentyHire platform, you agree to be bound by these Terms of Service. These terms apply to all visitors, users, and others who access or use our service. As a job seeker, you may use our platform to search for jobs, apply to positions, and create a professional profile. As an employer or recruiter, you may post job listings, search for candidates, and manage your hiring process through our platform."}
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#333",
                mb: 2,
                mt: 4,
              }}
            >
              {t("policies.privacyPolicyTitle") || "Privacy Policy"}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#666",
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              {t("policies.privacyPolicyContent") ||
                "We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how TalentyHire collects, uses, and shares information about you when you use our services. This includes information you provide directly to us and information we obtain from third parties. We use this information to provide, maintain, and improve our services, to communicate with you, and to comply with legal obligations. We do not use cookies or similar tracking technologies on our platform."}
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#333",
                mb: 2,
                mt: 4,
              }}
            >
              {t("policies.changesToPoliciesTitle") || "Changes to Our Policies"}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#666",
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              {t("policies.changesToPoliciesContent") ||
                "TalentyHire reserves the right to update or change our policies at any time. Any changes will be posted on this page with an updated revision date. We encourage you to review our policies periodically for any changes. Changes to our policies are effective immediately after they are posted. Your continued use of the TalentyHire platform after any modifications to the policies constitutes your acceptance of those changes."}
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#333",
                mb: 2,
                mt: 4,
              }}
            >
              {t("policies.contactUsTitle") || "Contact Us"}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "#666",
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              {t("policies.contactUsContent") ||
                "If you have any questions about these policies or the TalentyHire platform, please contact us at legal@talentyhire.com or by mail at our company address. For general support inquiries, you can reach our support team at support@talentyhire.com. We aim to respond to all inquiries within 48 business hours."}
            </Typography>
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default Policies;